import * as React from 'react';
import { observer } from 'mobx-react';
import { classes } from '../../utils/Classes';
import { PriceFormatted } from '@estee/elc-formatters';
import { IPrice } from '../../interfaces/IVto';

export interface IVtoProductPrice {
    formattedPricePerUnit?: string;
    prices: IPrice[];
}

const productPricePerUnitClassNames = classes('product-price-per-unit');

export const VtoProductPrice = observer(({ formattedPricePerUnit, prices }: IVtoProductPrice) => {
    const pricePerUnit = formattedPricePerUnit || prices[0].pricePerUnitFormatted;

    if (!pricePerUnit) {
        return null;
    }

    return (
        <PriceFormatted
            className={productPricePerUnitClassNames}
            formattedPrice={pricePerUnit}
            priceTag="p"
        />
    );
});
